module.exports = __webpack_public_path__ + "static/assets/20e38f264d2f5995b1bae447598b0539.png";